<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" href="#"><img src="assets/img/logo.png" style="cursor: pointer"></a>

  <div class="collapse navbar-collapse">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item" style="margin-left: 797px;">
        <app-language-picker></app-language-picker>
      </li>
    </ul>
  </div>

</nav>
